module.exports = __webpack_public_path__ + "73bf0fb40076d71521d456e009bb85e0.pdf";